import { MediaContentDTO } from '@touche-lts/panel-ui/dist'
import { makeAutoObservable } from 'mobx'
import RootStore  from 'mobx-stores/root-store'
import { ProductsDTO } from 'models/products'
import { getMyStoreProductsPath } from 'routes'
import { Api } from 'services'

export class ViewProductsPageStore {
  private rootStore:any
  private storeApi: Api['storeApi']
  private productsApi : Api['productsApi']

  constructor (rootStore:any) {
    this.rootStore = rootStore;
    this.storeApi = this.rootStore.generalStore.api.storeApi;
    this.productsApi = this.rootStore.generalStore.api.productsApi;
    makeAutoObservable(this);
  }

  // OBSERVABLES
  public store: ProductsDTO = null
  public productId: number | string = null;

  // ACTIONS
  public setStore = (store: ProductsDTO): void => {
    this.store = store
  }

  public setStoreProps = (props: Partial<ProductsDTO>): void => {
    this.setStore({ ...this.store, ...props })
  }

  public setProductId = (productId: string | number): void => {
    this.productId = productId;
  }

  public getProductById = async (productId: number | string): Promise<ProductsDTO> => {
    const store = await this.storeApi.getProductById(productId);
    const currentStoreId = store?.storeId || store?.store?.id || this.rootStore.userStore.effectiveStoreId;
    if(!store) return;
    this.setStore(store); // set main store
    this.rootStore.productsDetailsStore.setProductDetailsStore(store); // set product details store
    this.rootStore.productsDetailsStore.getAllDepartments() // det all departments
    this.setImageStore(productId); // set product images store
    this.rootStore.productsShippingsStore.getBrandShippings(currentStoreId, store.shippings); // set shippings store
    this.rootStore.productsSKUsStore.setProductSKUs(store.mainSku); // set SKUs store
    this.rootStore.productsSKUTableStore.setSearchResults(store.productSkus); // set Table store
  }

  public updateProduct = async (sectionInfo: any, productId: number | string): Promise<ProductsDTO> => {
    const storePayload = {...this.productPayload(), ...sectionInfo}; // TODO-A To remove this part once the bd allows partial updates of the data(it needs to be patch request) 
    const store = await this.productsApi.updateProducts(storePayload, productId);
    if(!store) return;
    // this.setStore(store);
  }

  public updateProductImages = async (productImages: MediaContentDTO[], productId: number | string): Promise<MediaContentDTO[]> => {
    const images = await this.productsApi.updateProductImages(productId, productImages);
    if(!images) return;
    this.rootStore.productsImagesStore.setInitialImages(images);
    return images
  } 

  public InitStores = () => {
    this.rootStore.productsDetailsStore.InitProductDetails();
    this.rootStore.productsSKUsStore.InitProductSKUs();
    this.rootStore.productsImagesStore.InitProductImages();
  }

  public addNewProduct = async (storeId: number) => {
    const {
      showSuccess,
      showError
    } = this.rootStore.generalStore,
    { push } = this.rootStore.routingStore,
    storePayload = this.productPayload();
    try {
      await this.storeApi.addNewProduct(storeId, storePayload);
    } catch (error) {
      if(error) return showError(error.message);
    }
    showSuccess('Product has been created!')
    push(getMyStoreProductsPath(this.rootStore.userStore.managementStoreId))
  }

  private setImageStore = async (productId: number | string): Promise<MediaContentDTO[]> => {
    const images = await this.productsApi.getProductImages(productId);
    if(!images) return;
    this.rootStore.productsImagesStore.setInitialImages(images);
  }

  private productPayload = (): Partial<ProductsDTO> => {
    const { productDetailsStore } = this.rootStore.productsDetailsStore;
    const { productSKUsStore } = this.rootStore.productsSKUsStore;
    const { setBrandingListForSave } = this.rootStore.productsShippingsStore;
    const { productImagesStore } = this.rootStore.productsImagesStore;
    return {...productDetailsStore ,mainSku: {...productSKUsStore}, shippings: [...setBrandingListForSave()], images: [...productImagesStore]};
  }

  // COMPUTE
  public get getProductId(): string | number {
    return this.productId;
  }

}